export default {
  row: {
    container: ['row', 'gap-3', 'wrap'],
    locationsItem: ['cell-4', 'grow', 'cell-md-12'],
    stopOverItem: ['cell-3', 'cell-md-6'],
    tripTypeContainer: ['cell-12', '-order-1'],
    datePickerContainer: ['cell-3', 'grow'],
    timeContainer: ['cell-2', 'grow'],
    passengersContainer: ['cell-2', 'grow'],
    discountsContainer: ['cell-2', 'grow'],
    submitContainer: ['cell'],
    addonContainer: ['cell-12', 'order-6'],
  },
  'row-2': {
    container: ['row', 'gap-3', 'wrap'],
    locationsItem: ['cell-8', 'grow', 'order-1'],
    stopOverItem: ['cell-3', 'order-1'],
    tripTypeContainer: ['cell-12', '-order-1'],
    datePickerContainer: ['cell-4', 'grow', 'order-3'],
    timeContainer: ['cell-4', 'grow', 'order-3'],
    passengersContainer: ['cell-4', 'grow', 'order-2'],
    discountsContainer: ['cell-4', 'grow', 'order-4'],
    submitContainer: ['cell-12', 'cell-lg-4', 'order-5'],
    addonContainer: ['cell-12', 'order-4', 'order-lg-6'],
  },
  column: {
    container: ['column', 'gap-5'],
    locationsItem: ['cell'],
    stopOverItem: ['cell'],
    tripTypeContainer: ['cell'],
    datePickerContainer: ['cell'],
    timeContainer: ['cell'],
    passengersContainer: ['cell'],
    discountsContainer: ['cell'],
    submitContainer: ['cell', 'mt-1'],
    addonContainer: ['cell', 'mt-1'],
  },
}
